import { render } from "./App.vue?vue&type=template&id=50bb7603"
const script = {}

import "./App.vue?vue&type=style&index=0&id=50bb7603&lang=css"

import exportComponent from "/builds/gh_devops/currency_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__